import * as React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dropdown } from "antd";
import { actionType } from "./AIDocumentsTable";
import { pdfViewerStore } from "Stores/PdfViewerStore";
import { ItemType } from "antd/lib/menu/interface";

interface TableActionsDropdownProps {
  fileId: number;
  easyViewer?: boolean;
  fileName?: string;
  hasCertainties?: boolean;
  onClick: (id: number, type: actionType) => void;
}

export class TableActionsDropdown extends React.Component<TableActionsDropdownProps> {
  handleClick = ({ key }) => {
    const { fileId, onClick, fileName } = this.props;
    if (key === "view") {
      pdfViewerStore.fetch(fileId, { page: 1, fileName });
      return;
    }
    onClick(fileId, key);
  };

  get menuItems(): ItemType[] {
    const { hasCertainties, easyViewer } = this.props;
    const items: ItemType[] = [];

    if (hasCertainties) {
      items.push(
        {
          key: "move",
          label: (
            <>
              <FontAwesomeIcon icon={["far", "arrow-circle-right"]} fixedWidth={true} /> Move-to
            </>
          ),
        },
        {
          key: "analyze",
          label: (
            <>
              <FontAwesomeIcon icon={["far", "chart-pie"]} fixedWidth={true} /> Analyze content
            </>
          ),
        }
      );
    }

    if (easyViewer) {
      items.push({
        key: "view",
        label: (
          <>
            <FontAwesomeIcon icon={["far", "eye"]} fixedWidth={true} /> View
          </>
        ),
      });
    }

    return items;
  }

  render() {
    return this.menuItems.length ? (
      <Dropdown menu={{ items: this.menuItems, onClick: this.handleClick }}>
        <div style={{ width: 40, textAlign: "center", margin: `0 auto` }}>
          <FontAwesomeIcon icon={"ellipsis-v"} />
        </div>
      </Dropdown>
    ) : null;
  }
}
